module.exports = __webpack_public_path__ + "static/tv-kid-863bc808c10a2ac2cb050df4ec24748c.png";